<template>
  <div class="lecturerComponent">
    <!-- Spinner loading indicator -->
    <div class="spinner-border text-primary" role="status" v-if="isLoading">
      <span class="sr-only">Loading...</span>
    </div>

    <div class="items">
      <div class="box" v-if="totalCount > 0">
          <div class="item" v-for="item in currentItems" :key="item.id">
            <div class="picBox">
              <a :href="`lecturer/${item.slug}`">
                <img class="pic" :src="getUserPic(item)" @error="handleImageError" alt="">
              </a>
            </div>
            <div class="name" v-html="item.name"></div>
            <div class="jobTitle" v-html="item.jobTitle"></div>
            <div class="splide__slide"></div>
            <div class="subTitle">簡介</div>
            <div class="shortDescriptionWrapper">
              <div class="shortDescription" :class="{'collapsed': !item.showFullDescription && shouldShowToggleButton(item)}" v-html="item.shortDescription"></div>
              <button v-if="!item.showFullDescription && shouldShowToggleButton(item)" @click="toggleDescription(item)">
                {{ item.showFullDescription ? '收起' : '✚ 展開全部' }}
              </button>
            </div>
            <div class="subTitle">經歷/資歷</div>
            <div class="experienceWrapper">
              <span class="text-left" :key="index" v-for="(experience, index) in item.LecturerField.experience" v-html="experience"></span>
            </div>
          </div>
      </div>
      <div v-else class="emptyText">搜尋不到專業人士</div>
    </div>
    <div class="pagination">
      <span class="link"
        :class="{active: currentPage === 1, disabled: isLoading}"><a :href="getPageLink(1)">1</a></span>
      <span v-if="currentPage > 3"
            :class="{disabled: isLoading}">...</span>
      <span v-for="page in surroundingPages" class="link"
            :class="{active: currentPage === page, disabled: isLoading}"><a :href="getPageLink(page)">{{ page }}</a></span>
      <span v-if="currentPage < (lastPage - 3) "
            :class="{disabled: isLoading}">...</span>
      <span v-if="lastPage > 1" class="link"
            :class="{active: currentPage === lastPage, disabled: isLoading}"><a :href="getPageLink(lastPage)">{{ lastPage }}</a></span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LecturerComponent',
  components: {
  },
  props: {
    items: {
      type: Array,
      default: [],
    },
    lastPage: {
      type: Number,
      default: 1,
    },
    nowPage: {
      type: Number,
      default: 1,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    searchKey: {
      type: Object,
      default: {
        classMetaId: null,
        keyword: null,
      },
    },
  },
  data() {
    return {
      isLoading: false,
      fetchedPages: [],
      pagesData: {},
      currentPage: this.nowPage,
      currentItems: this.items,
    };
  },
  mounted() {
  },
  computed: {
    surroundingPages() {
      const pages = [];
      const start = Math.max(2, this.currentPage - 2);
      const end = Math.min(this.lastPage - 1, this.currentPage + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  methods: {
    getPageLink (pageNum) {
      let path = '/lecturer';
      const params = new URLSearchParams();
      params.append('page', pageNum);
      if (this.searchKey.classMetaId) {
        params.append('classMetaId', this.searchKey.classMetaId);
      }
      if (this.searchKey.keyword) {
        params.append('keyword', this.searchKey.keyword);
      }
      const queryString = params.toString();
      if (queryString) {
        // eslint-disable-next-line no-unused-vars
        path += `?${queryString}`;
      }
      return path;
    },
    handleImageError(event) {
      event.target.src = 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg';
    },
    getUserPic(item) {
      return item?.Pics[0]?.url['w0h0'] ?? 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg';
    },
    toggleDescription(item) {
      this.currentItems = this.currentItems.map(i => {
        if (i.id === item.id) {
          return { ...i, showFullDescription: !i.showFullDescription };
        }
        return i;
      });
    },
    shouldShowToggleButton(item) {
      // 判斷字數是否超過一定數量
      return item.shortDescription && item.shortDescription.length > 100;
    },
  },
};
</script>

<style scoped lang="scss">

.spinner-border{
  margin: 50px 50%;
}

.disabled {
  pointer-events: none;
  opacity: 0.6;  /* 降低透明度，使其看起來像是被禁用的 */
}

.items {
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* 間距 */
  justify-content: flex-start;
  .box {
    display: flex;
    flex-wrap: wrap;
    gap: 16px; /* 間距 */
    justify-content: flex-start;
    width: 100%;
    .item {
      flex: 0 1 calc(33.33% - 32px); /* 每行三個 */
      max-width: calc(33.33% - 32px);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 16px;
      text-align: center;
      position: relative;
      @media (max-width: 768px) {
        flex: 0 1 calc(50% - 32px); /* 每行兩個 */
        max-width: calc(50% - 32px);
      }
      @media (max-width: 479.98px) {
        flex: 0 1 calc(100% - 32px); /* 每行兩個 */
        max-width: calc(100% - 32px);
      }

      .subTitle {
        font-weight: bold;
        color: #333;
        width: 75%;
        margin-top: 1rem;
        font-size: 18px;
        margin-bottom: 1rem;
        text-align: left;
      }

      .picBox {
        position: relative;
        width: 55%;
        margin: 20px 0;
      }

      .pic {
        width: 100%;
        border-radius: 50%;
        box-shadow: 7px 5px 0 1px #72ca4a;
        overflow: hidden;
      }

      .name {
        width: 55%;
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 10px;
      }

      .jobTitle {
        width: 55%;
        color: #72CA4AFF;
        font-size: 14px;
        margin-bottom: 1rem;
        position: relative;
      }
      .splide__slide{
        width: 90%;
        margin-bottom: 1rem;
        border-bottom: solid 3px #72ca4a;
      }
      .shortDescriptionWrapper {
        width: 75%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .shortDescription {
          font-size: 12px;
          margin-bottom: 10px;
          text-align: left;
          &.collapsed {
            max-height: 50px;
            overflow: hidden;
            position: relative;
            &:after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              height: 30px;
              background: linear-gradient(180deg, transparent, #f9f9f9);
            }
          }
        }
        button {
          background: none;
          border: none;
          color: #72ca4a;
          cursor: pointer;
          padding: 0;
          margin-top: 10px;
          font-size: 1em;
          text-align: center;
          width: 100%;
        }
      }
      .experienceWrapper{
        width: 75%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: left;
        span{
          width: 100%;
        }
      }
    }
  }
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  span {
    margin: 0 5px;
    padding: 5px 10px;
    border: 1px solid #ddd;
    &.link{
      cursor: pointer;
      &:hover, &.active {
        color: #72ca4a;
        border-color: #72ca4a;
        a {
          color:#72ca4a;
        }
      }
    }
    a {
      color:#555;
    }
  }
}
.relatedTitleBox {
  margin-bottom: 0rem;
}
.more {
  position: relative;
  font-size: 14px;
  color: #555;
  cursor: pointer;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 50%;
    height: 1px;
    background-color: #999;
  }
  &:hover {
    transition: 0.4s;
    color: #72ca4a;
    &::after {
      width: 100%;
      background: #72ca4a;
      transition: 0.3s linear;
    }
  }
}
</style>
